import React from 'react';

import { commonAPI } from 'api/commonAPI';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import user from '../../../assets/images/Ellipse6.png';
import icon from '../../../assets/images/Group90.png';
import {fadeIn} from "../../../styled/StyledComponent";
import {useRecoilValue} from "recoil";
import {userInfo} from "../../../state";

const Header:React.FC = () => {
  const calculateScrollDistance = () => {
    const scrollDistance = window.scrollY;
    console.log('Scroll Distance:', scrollDistance);
  };
  const navigate = useNavigate();

  const onClickLogout = async () => {
    await commonAPI.userLogout()
    .then(res => {
      if(res?.success){
          setTimeout(()=>{
              sessionStorage.removeItem('accessToken');
          },200)

          navigate("/login")
          setTimeout(()=>{
            window.location.reload();
          },150)
      }
    })
  };

    const user = useRecoilValue(userInfo);
    // console.log("@",);
return(
  <Container>
    {/*<Search>*/}
    {/*  <input type="text" placeholder={"Search"} />*/}
    {/*  <div className="border" />*/}
    {/*</Search>*/}
    <Avatar>
      <img src={icon} />
    <div>
        <img
            className={"user"}
            onClick={onClickLogout}
            src={user?.profileImage?.url}/>
    </div>

    </Avatar>
  </Container>
)

}
export {Header};

const Container = styled.div`
    animation: ${fadeIn} 0.25s linear; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    background: #fff;
    height: 60px;
    width: 100%;
    flex: 1;    
    display: flex;
    justify-content: flex-end;
    padding-right: 30px;
    //border-bottom: 0.6px solid #33333320;
`;

const Search = styled.div`
  padding-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .border{
    width: 1px;
    height: 30px; 
    margin-left: 20px;
    background :#ddd ;
  }
  input{
    padding-left: 16px;
    display: flex;
    width: 180px;
    height: 36px;
    border-radius: 8px;
    outline: none;
    border: solid 1px #ddd;
    &::placeholder{
      opacity: 0.5;
    }
  }
`; 

const Avatar = styled.div`
  display: flex;
  align-items: center;
  & > div{
      width: 36px;
      height: 36px;
      
      border-radius: 50%;
      overflow: hidden;
      img{
          
          box-sizing: border-box;
          border: 0;
          display: flex;
          content: "";
          background: #ddd;
          width: 100%!important;
          height: 100%!important;
          object-fit: cover;
      }
  }
  img{
    display: block;
      
  
    &:nth-child(1){
      width: 24px;
      height: 24px;
      margin-right: 20px;
    }
    display: block;
    width: 36px;
    height: 36px;
  }
`; 